import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AddStopsTutorialPageRoutingModule } from './add-stops-tutorial-routing.module';

import { AddStopsTutorialPage } from './add-stops-tutorial.page';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, AddStopsTutorialPageRoutingModule, TranslateModule.forChild()],
  declarations: [AddStopsTutorialPage]
})
export class AddStopsTutorialPageModule {}
